import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const Nav = lazy(
    () => import(/* webpackChunkName: "profile-nav" */ '../../shared/nav')
);
const List = lazy(
    () => import(/* webpackChunkName: "profile-list" */ '../../shared/list')
);
import Form from './form';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render({ mode }) {
        return (
            <profiles-manager mode={mode}>
                <Suspense fallback={<div className='skeleton' />}>
                    <Nav />
                    <List mode={mode} />
                    <Form mode={mode} />
                </Suspense>
            </profiles-manager>
        );
    }
}

export default connect()(Component);